import {Price} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//price.types';
import {
  BrandTracker,
  ProductTracker,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {Brand} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/brand.types';
import {PriceV2} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/price_v2.types';
import {Product} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product.types';
import {ProductTileWishlistButton} from '@aboutyou/ui-components';
import React from 'react';
import {WishlistButton as WishlistButtonBase} from '../Wishlist/WishlistButton';

export const WishlistButton: React.FC<{
  brand: Brand | BrandTracker;
  product: Product | ProductTracker;
  price?: Price | PriceV2;
  streamPosition: number;
  trackingData?: {
    sortingChannel?: string;
  };
  isFocusable?: boolean;
  badgesListKeys: string[];
}> = ({
  brand,
  product,
  price,
  streamPosition,
  trackingData,
  isFocusable,
  badgesListKeys,
}) => {
  return (
    <WishlistButtonBase
      product={product}
      price={price}
      brand={brand}
      WishlistComponent={ProductTileWishlistButton}
      streamPosition={streamPosition}
      trackingData={trackingData}
      isFocusable={isFocusable}
      badgesListKeys={badgesListKeys}
    />
  );
};
